import React from "react";
import { Box, Stack } from "@mui/material";
import { PagePaper } from "@/components/Paper/PagePaper";
import { PageTitle } from "@/components/Title";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import { OrderForm } from "@/features/dmManagement/components/OrderForm";
import { useDesigns } from "@/features/dmManagement/hooks/useDesigns";
import { LinkButton } from "@/components/Button/LinkButton";
import { ButtonVariantOption } from "@/components/Button";
import { SizingWrapperStyle } from "@/components/Wrapper";

export const OrderFormPage: React.FC = () => {
  const { designs } = useDesigns({ status: "approved" });

  return (
    <PagePaper>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={3}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <ContactMailIcon sx={{ mr: 1 }} fontSize="large" />
          <PageTitle>注文作成</PageTitle>
        </Box>
        <LinkButton
          variant={ButtonVariantOption.Outlined}
          href="/dmManagement"
          wrapperSize={SizingWrapperStyle.INHERIT}
        >
          一覧に戻る
        </LinkButton>
      </Stack>
      <OrderForm approvedDesigns={designs ?? []} />
    </PagePaper>
  );
};
